export const tooltipTemplate = (
  stylecontext: string,
  node: HTMLElement,
) => `<tef-coms-tooltip cloak context="${stylecontext}" placement="bottom">
  ${node.innerHTML}
  <div slot="content">
    ${node.title}
  </div>
</tef-coms-tooltip>`;

export default tooltipTemplate;
